import React from "react";
import { useQuery } from "react-query";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Container } from "../../lib";
import { getFanReportLogPerMatch } from "../../../../api/report/reportApi";
import BackBtn from "../../lib/BackBtn";
import FanReportLogTable from "./FanReportLogTable";

const FanReportLogList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as { 
    userData?: { national_code: string },
    matchId?: number 
  } || {};
  
  React.useEffect(() => {
    if (!state.userData?.national_code || !state.matchId) {
      navigate(-1);
    }
  }, []);

  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") || "1");

  const { data, isLoading, isError, refetch } = useQuery(
    ["fanReportLog", page, state.userData?.national_code, state.matchId],
    () => {
      if (!state.userData?.national_code || !state.matchId) return null;
      return getFanReportLogPerMatch(state.userData.national_code, state.matchId);
    },
    {
      enabled: !!state.userData?.national_code && !!state.matchId
    }
  );

  const handlePageChange = (newPage: number) => {
    setSearchParams({ page: newPage.toString() });
  };

  if (isLoading) return <div>در حال بارگذاری...</div>;
  if (isError) return <div>خطا در دریافت اطلاعات</div>;
  if (!state.userData?.national_code) return <div>کد ملی نامعتبر است</div>;
  if (!state.matchId) return <div>شناسه مسابقه نامعتبر است</div>;

  return (
    <Container className="bg-white p-0 mt-10">
      <div className="d-flex align-items-center justify-content-between table-header">
        <div className="d-flex align-items-center gap-4">
          <h3>گزارش فعالیت‌های هوادار</h3>
        </div>
        <BackBtn onClick={() => navigate(-1)} />
      </div>

      {data?.tickets && data.tickets.length > 0 ? (
        <FanReportLogTable
          data={data}
          queryString={{ 
            page, 
            nationalCode: state.userData.national_code,
          }}
          matchId={state.matchId}
          setQueryString={handlePageChange}
          refetch={refetch}
        />
      ) : (
        <p className="p-2 m-2">اطلاعاتی یافت نشد</p>
      )}
    </Container>
  );
};

export default FanReportLogList;
